import ClientProfile from './ClientProfile';

export default ClientProfile;
